import { __rest } from 'tslib';
import React from 'react';
import { Field } from './Field/Field.js';
import { Help } from './Help/Help.js';
import { Label } from './Label/Label.js';
import { Message } from './Message/Message.js';
import { Container } from './styled.js';

const BaseForm = React.forwardRef((_a, ref) => {
    var { gap = 16, children } = _a, props = __rest(_a, ["gap", "children"]);
    return (React.createElement(Container, Object.assign({ "data-testid": 'tend-ui-form' }, props, { ref: ref, "$gap": gap }), children));
});
const Form = Object.assign(BaseForm, {
    displayName: 'Form',
    Field,
    Label,
    Message,
    Help,
});

export { Form };
//# sourceMappingURL=Form.js.map
